const messages = {
  name: 'Credit Consumption',
  fields: {},
  submenu: {
    costCenter: 'Cost Center',
    pricing: 'Pricing',
    creditBalance: 'Credit Balance',
    creditTransaction: 'Credit Transaction',
    creditEventLogs: 'Credit Event Logs',
    creditEventSummary: 'Credit Event Summary',
  },
};

export default messages;
